import styles from './TextBox.module.scss';

import cx from 'classnames';
import React from 'react';

import { TextStack, ITextStackProps } from '../../TextStack/TextStack';

interface ITextBox extends ITextStackProps {
  rightAligned?: boolean;
  ctaButton?: boolean;
}

const TextBox: React.FC<ITextBox> = ({ rightAligned, className, ctaButton, ...props }) => (
  <TextStack
    className={cx(styles.textBox, className)}
    titleTagName="h2"
    titleClassName={styles.title}
    blurbClassName={styles.blurb}
    linkClassName={cx({
      btn: ctaButton,
      [styles.ctaButton]: ctaButton,
      [styles.ctaLink]: !ctaButton,
    })}
    showLinkArrow={!ctaButton}
    isButton
    buttonSize="small"
    {...props}
  />
);

export { TextBox };
